import { SiteDetails } from "src/components/Premises/types";
import { accountBlockInitialValues } from "../FormComponents/Validations";
import { IMessageAttachmentRest } from "../Messages/types";
import {
  AccountBlockValues,
  AccountPayer,
  Contact,
  RequestingCompany,
} from "../types";
import { Company } from "src/components/Projects/types";
import { UserInfo } from "src/context/AppContext";

export interface ClaimDialogValues {
  requestingCompany: null | RequestingCompany;
  projectId: string;
  projectName: string;
  requestId: string;
  currentClaimTarget?: ComputedClaimableJourney | null;
  siteSupervisorId?: string;
}
export interface HomeUserClaimDialogValues {
  requestId: string;
  currentClaimTarget?: ComputedClaimableJourney | null;
  siteSupervisorId?: string;
}

export const claimDialogInitialValues = {
  requestingCompany: null,
  projectId: "",
  projectName: "",
  requestId: "",
  currentClaimTarget: null,
};

export const homeUserClaimDialogInitialValues = {
  requestId: "",
  currentClaimTarget: null,
  claimsCustomerConsentFiles: [],
  siteSupervisors: [],
  licensedPlumbers: [],
  electricityAccountPayer: AccountPayer.COMPANY,
  siteSupervisor: "",
};

export interface ClaimFormValues extends AccountBlockValues, ClaimDialogValues {
  electricityAccountPayer: string;
  siteSupervisor: string;
  siteSupervisors: Contact[];
  licensedPlumbers: Contact[];
  attachmentMeta?: any;
  electricityLifeSupport?: boolean;
}

export interface HomeUserClaimFormValues
  extends AccountBlockValues,
    HomeUserClaimDialogValues {
  electricityAccountPayer: string;
  siteSupervisor: string;
  siteSupervisors: Contact[];
  licensedPlumbers: Contact[];
  attachmentMeta?: any;
}

export const claimFormInitialValues = {
  ...claimDialogInitialValues,
  ...accountBlockInitialValues,
  claimsCustomerConsentFiles: [],
  electricityAccountPayer: AccountPayer.COMPANY,
  siteSupervisor: "",
  siteSupervisors: [],
  licensedPlumbers: [],
};

export enum ClaimableItemType {
  JOURNEY = "journey_id",
  DB = "db_application_id",
}

export enum ClaimableStates {
  CLAIMABLE = "CLAIMABLE",
  CLAIMED = "CLAIMED",
  CLAIMED_BY_SOMEONE_ELSE = "CLAIMED_BY_SOMEONE_ELSE",
  NOT_FOUND = "NOT_FOUND",
  COMPLETED = "COMPLETED",
}

export interface ClaimableJourney {
  journey_id?: string;
  distributor_application_id?: string;
  claimed: boolean;
  claimable_state: boolean;
  has_repeated_distributor: boolean;
  property_details: ClaimableJourneyPropertyDetails;
  claimed_request_company: Company;
  claimed_request_oc_number: string;
  claimed_request_creator: UserInfo;
  user_access_to_requesting_company: string;
}
export interface ClaimableJourneyPropertyDetails {
  id?: string | null;
  attachments_meta?: IMessageAttachmentRest[] | null;
  property_type: string;
  site_details: SiteDetails;
  unit_type: string;
  unit_number: string;
}

export interface ComputedClaimableJourney {
  claimableJourney?: ClaimableJourney | null;
  computedState: ClaimableStates;
}

export interface IClaimRest {
  requestId: string;
  electricityAccountPayer: AccountPayer;
  msaNumber?: string;
  accountDetails?: AccountRest;
  attachments_meta?: IMessageAttachmentRest[] | null;
}

interface AccountRest {
  id: string;
  first_name: string;
  last_name: string;
  company_name: string;
  company_number: string;
  communication_preference: string;
  phone_number: string;
  email: string;
  date_of_birth: Date;
  postal_address_same_as_premise: string;
  postal_address: {
    street_number: string;
    street_name: string;
    street_suffix: string;
    street_type: string;
    unit_type: string;
    floor_number: string;
    unit_number: string;
    postcode: string;
    suburb: string;
    state: string;
    building_name: string;
    postal_delivery_type: string;
    postal_delivery_number_value: string;
  };
  secondary_account: {
    add_second_name_to_bill: string;
    first_name: string;
    last_name: string;
    phone_number: string;
    email: string;
    date_of_birth: string;
  };
}
